// removed by extract-text-webpack-plugin
module.exports = {"component":"_37RmOZZwpiQju7jpkuE0Tm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/PaymentButton/PaymenteMessage/PaymentInProgress/PaymentLoader/paymentLoader.css
// module id = 1069
// module chunks = 2